import { default as app, collapsibleHeaderClickEvent, onWindowResize, resetSelectionColumn, ToggleYellowToGreen, ToggleGreenToYellow, IsUndefinedOrNull } from '@legacy/App';

app.factory('CompanyFactory', ['$http','settings', function ($http, settings) {
    return {
        getNewCompany: function () {
            return $http.get(settings.ApiURL + settings.CompanyURL + "/newcompany");
        },
        getCompanyDetails: function (id) {
            return $http.get(settings.ApiURL + settings.CompanyURL + "/" + id);
        },
        saveCompany: function (company) {
            return $http.put(settings.ApiURL + settings.CompanyURL, company);
        },
        deleteCompany: function (id) {
            return $http.delete(settings.ApiURL + settings.CompanyURL + "/" + id);
        },
        getCompanyList: function () {
            return $http.get(settings.ApiURL + settings.CompanyURL);
        },
        getCompanyDropDown: function(lookup) {
            return $http.get(settings.ApiURL + settings.CompanyURL + "/dropdown/" + lookup)
        },
        getNonPrintCompanyList: function (lookup) {
            return $http.get(settings.ApiURL + settings.CompanyURL + "/nonprintcompanydropdown/" + lookup)
        },
        getMsgReceiverGroups: function (lookup) {
            return $http.get(settings.ApiURL + settings.CompanyURL + "/GetMsgReceiverGroups")
        },
        getAutoEmailOptionsList: function(lookup) {
            return $http.get(settings.ApiURL + settings.CompanyURL + "/GetAutoEmailOptionsList");
        },
    };
}]);

app.controller('CompanyController', ['$q', '$scope', 'CompanyFactory', 'CustomerFactory', '$rootScope', 'settings', 'masterFactory', '$uibModal',
                            function ($q, $scope, CompanyFactory, CustomerFactory, $rootScope, settings, masterFactory, $uibModal) {
    $rootScope.pageTitle = "Company";
    $scope.companies = [];
    $scope.billingCustomerList = [];
    $scope.company = {};
    $scope.newCompany = {};
    $scope.error = "";
    $scope.modelState = [];
    $scope.msgReceiverGroups = [];
    $scope.isFormVisible = false;
    $scope.pageSize = 20;
    $scope.AutoEmailOptionsLists = [];
     
    // Initialization - this runs on load
    var init = function (pageIndex) {
        masterFactory.verifyAuthentication();
        

        $q.all([
            CompanyFactory.getCompanyList().success(function (data) {
                $scope.companies = data;
                $scope.refreshGrid(0,null);                
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            CompanyFactory.getNewCompany().success(function (data) {
                $scope.newCompany = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            CompanyFactory.getMsgReceiverGroups().success(function (data) {
                $scope.msgReceiverGroups = data;
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }),
            CompanyFactory.getAutoEmailOptionsList().success(function (data) {
                $scope.AutoEmailOptionsLists = data.filter(function (s) { return s.name != 'None' });
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            })                       
        ]).then(function () {
        });
        
    };

    var getCompany = function (id) {
        CompanyFactory.getCompanyDetails(id).success(function (data) {
            $scope.company = data;
            $rootScope.user.DefaultCustomerId = data.DefaultCustomer;
            $rootScope.user.DefaultCustomerName = data.DefaultCustomerName;
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        });
    };

    init(0);
    
    // Grid renderers
    $scope.refreshGrid = function (PageIndex, Key) {        
        $('#gridCompany').dxDataGrid({
            dataSource:{
                store: {
                    data: $scope.companies,
                    type: 'array',
                    key: 'Id'
                }
            },                
            noDataText: "No Companys Found",
            showColumnLines: true,
            showRowLines: false,
            showBorders: true,
            rowAlternationEnabled: false,
            contentReadyAction: grdReadyAction,
            selection: { mode: 'single' },
            paging: {
                pageSize: $scope.pageSize,
                pageIndex: PageIndex
            },
            scrolling: {
                mode: 'standard'
            },
            sorting: {
                mode: 'single' 
            },
            pager: {
                showPageSizeSelector: true,
                allowedPageSizes: [10, 20, 30]
            },
            filterRow: {
                visible: true
            },
            groupPanel: {
                visible: false,
            },
            columns: [
               {
                   caption: 'Name',
                   dataField: 'name',
                   cssClass: 'name',
                   dataType: 'string',
                   alignment: 'center',
                   sortIndex: 0,
                   sortOrder: 'asc',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.name)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               },
               {
                   caption: 'Description',
                   dataField: 'name2',
                   cssClass: 'name2',
                   dataType: 'string',
                   alignment: 'center',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.name2)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               },
               {
                   caption: 'Address',
                   dataField: 'StreetAddress',
                   cssClass: 'StreetAddress',
                   dataType: 'string',
                   alignment: 'center',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.StreetAddress)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               },
               {
                   caption: 'Suburb',
                   dataField: 'Suburb',
                   cssClass: 'Suburb',
                   dataType: 'string',
                   alignment: 'center',
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.Suburb)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               },
               {
                   caption: 'Post Code',
                   dataField: 'ZipCode',
                   cssClass: 'ZipCode',
                   dataType: 'string',
                   alignment: 'center',
                   width: 150,
                   cellTemplate: function (container, options) {
                       $('<span />')
                       .text(options.data.ZipCode)
                       .appendTo(container);
                       container.addClass('grid-cell-align-left');
                   }
               }
            ],
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    getCompany(selectedRowsInfo.selectedRowsData[0].Id);                    
                }
                else $scope.company = angular.copy($scope.newCompany);                
                             
                $scope.isFormVisible = true;
                $scope.isDeleteVisible = true;
                ToggleYellowToGreen();
                $rootScope.pageTitle = "Company";                
            }

        });
    };

    $scope.viewBillingCustomerModal = function () {
      $uibModal.open({
            templateUrl: 'app-legacy/Entities/templates/defaultCustomerModel.html',
            controller: 'BillingCustomerController',
            size: 'lg',
            scope: $scope,
            windowTemplateUrl: 'app-legacy/Entities/templates/modal-scrollable-content.html'
        });
    };
    
    // Button click functions and submit form function
    $scope.addNewEntity = function () {
        $rootScope.pageTitle = "New Company";
        $scope.isFormVisible = true;
        $scope.isDeleteVisible = false;
        $scope.company = angular.copy($scope.newCompany);        
        ToggleGreenToYellow();        
    };

    $scope.confirmDeleteEntity = function () {
        $('#DeleteModal').modal({ backdrop: 'static' });
    };

    $scope.deleteEntity = function (value) {
        if (value == 0) {
            $('#DeleteModal').modal('hide');
        }
        else if (value == 1) {
            CompanyFactory.deleteCompany($scope.company.Id).success(function (data) {
                var dataGrid = $('#gridCompany').dxDataGrid('instance');
                var pageIndex = dataGrid.pageIndex();
                $scope.pageSize = dataGrid.pageSize();
                dataGrid.clearSelection();
                init(pageIndex);
                $scope.isFormVisible = false;
                $scope.notify.add({ type: 'success', title: 'Success!', body: 'Deleted Company successfully' });
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                $('#DeleteModal').modal('hide');
            });
        }
    };

    $scope.cancelForm = function () {
        var dataGrid = $('#gridCompany').dxDataGrid('instance');
        dataGrid.clearSelection();
        $scope.isFormVisible = false;
        $scope.companyForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
    };

    $scope.reset = function (type) {
        if (type == 'update') { // get db bankaccount and set to scope.bankaccount.
            getCompany($scope.company.Id);
        }
        else {
            angular.copy($scope.newCompany, $scope.company);
        }
        //if ($scope.companyCopy != null && !angular.equals($scope.company, $scope.companyCopy)) {
        //    $rootScope.pageTitle = "Company";
        //    angular.copy($scope.companyCopy, $scope.company);
        //}
        //else {
        //    $rootScope.pageTitle = "New Company";
        //    $scope.company = angular.copy($scope.newCompany);
        //    $scope.companyCopy = angular.copy($scope.company);
        //}        
        //ToggleYellowToGreen();
        $scope.companyForm.$setPristine();
        $scope.companyForm.submitted = false;
        $scope.closeModelStateErrors();
        $scope.closeAlert();
        $scope.notify.add({ type: 'success', title: 'Success!', body: 'Company details were reset' });        
    };

    $scope.submitForm = function () {
        if ($scope.companyForm.$valid) {
            if ($scope.company.Id != null && $scope.company.Id > 0) {  // update
                $scope.saveCompany($scope.companies.IsPrintCompany);
                $scope.companyForm.submitted = false;
            }
            else { // new company
                $('#SaveModal').modal({ backdrop: 'static' });
            }
        } else {
            $scope.companyForm.submitted = true;
        }
    };

    $scope.saveCompany = function (IsPrintCompany) {
        $('#SaveModal').modal('hide');
        var pageindex, id;
        $scope.company.IsPrintCompany = IsPrintCompany;
        $scope.company.DefaultCustomer = $rootScope.user.DefaultCustomerId;
        $('#loadingModal').modal({ backdrop: 'static' });
        CompanyFactory.saveCompany($scope.company).success(function (data) {
            CompanyFactory.getCompanyList($rootScope.accessToken).success(function (data) {
                var dataGrid = $('#gridCompany').dxDataGrid('instance');
                $scope.pageSize = dataGrid.pageSize();
                pageindex = dataGrid.pageIndex();
                $scope.companies = data;
                if ($scope.company.Id > 0) {
                    $scope.refreshGrid(pageindex, $scope.company.Id)
                }
                else {
                    $scope.cancelForm();
                    $scope.refreshGrid(pageindex, null);
                }
            }).error(function (data, status) {
                masterFactory.setError(status, data, $scope);
            }).finally(function () {
                if ($scope.company.Id > 0) {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Updated Company successfully' });
                }
                else {
                    $scope.notify.add({ type: 'success', title: 'Success!', body: 'Created Company successfully' });
                }
            });
        }).error(function (data, status) {
            masterFactory.setError(status, data, $scope);
        }).finally(function () {
            $('#loadingModal').modal('hide');
        });
    }

    // Helping functions and events
    $(window).resize(function () {
        onWindowResize('#gridCompany', settings.GridMarginHeight);
    });

    function grdReadyAction(e) {
        onWindowResize('#gridCompany', settings.GridMarginHeight);
    }

    collapsibleHeaderClickEvent($scope);

    $scope.closeAlert = function () {
        $scope.error = null;
    };

    $scope.closeModelStateErrors = function () {
        $scope.modelState = [];
    };

    $scope.clickHalfDiv = function (control) {
        masterFactory.setFocus(control);
    };

    $scope.filter = function (input, id) {
        var i = 0, len = input.length;
        for (; i < len; i++) {
            if (+input[i].Id == +id) {
                return input[i];
            }
        }
        return null;
    };
}]);

app.controller('BillingCustomerController',['$q', '$scope', 'CustomerFactory', 'settings', 'masterFactory', '$uibModalInstance', '$rootScope',
    function ($q, $scope, CustomerFactory, settings, masterFactory, $uibModalInstance, $rootScope) {
    $scope.filterOptions = {
        CustomerNo: null, CustomerName: null, CustomerAddress: null,
        GridPagerOptions: { PageIndex: 0, PageSize: 20, TotalPages: null }
  };
  $scope.TotalCount = null;
  $scope.BillingcustomerGridDataSource = [];
  $scope.BillingCustomerName = [];
  $scope.TitleName = "Billing Customer";

    $scope.customerGridDataSource = function() {
        var dataSource = {store: new DevExpress.data.CustomStore({
            // DataSource Configuration
            key: ["Id", "Position"],
            pageSize: $scope.PageSize,
            // Data Access Logic
            load: function (loadOptions) {
                var d = $.Deferred();
                var params = {};

                if (loadOptions != undefined) {
                    $scope.filterOptions.CustomerName = null;
                    $scope.filterOptions.CustomerAddress = null;
                    $scope.filterOptions.CustomerNo = null;
                    if (loadOptions.filter != undefined) { // accessing grid filter values                         
                        for (var i = 0; i < loadOptions.filter.length; i++) {
                            if (loadOptions.filter[i].length == 3) {
                                if (loadOptions.filter[i][0] == "Name1") $scope.filterOptions.CustomerName = loadOptions.filter[i][2];
                                else if (loadOptions.filter[i][0] == "Id") $scope.filterOptions.CustomerNo = loadOptions.filter[i][2];
                            }
                        }
                    }
                    $scope.filterOptions.GridPagerOptions.PageSize = (IsUndefinedOrNull(loadOptions.take) == true) ? $scope.PageSize : loadOptions.take;
                    $scope.filterOptions.GridPagerOptions.PageIndex = ((IsUndefinedOrNull(loadOptions.take) && IsUndefinedOrNull(loadOptions.skip)) == true) ? 0 : (loadOptions.skip / loadOptions.take);
                }
                CustomerFactory.getBillingCustomers($scope.filterOptions).success(function (data) {
                    d.resolve(data.BillingCustomerListVM, { totalCount: data.TotalCount });
                    $scope.TotalCount = data.TotalCount;
                }).error(function (data, status) {
                    masterFactory.setError(status, data, $scope);
                }).finally(function () {
                });
                return d.promise();
            },
            byKey: function (key, extra) {
            },
            update: function (values) {
            }
        })
    }
    return dataSource;
    };

    // Grid renderers
    $scope.refreshGrid = function (PageIndex, Key) {
        $scope.originalId = 0;
        $scope.originalPos = 0;
        $scope.error = '';
        $('#gridBillingCustomer').dxDataGrid({
            columns: [
                { caption: 'Customer Id', dataField: 'Id', cssClass: 'Number', alignment: 'center', dataType: 'string', width: 100 },
                {
                    caption: 'Customer Name', dataField: 'Name1', cssClass: 'FullName', dataType: 'string', alignment: 'center',
                    cellTemplate: function (container, options) {
                        $('<span />')
                            .text(options.data.Name1)
                            .append("</br>")
                            .appendTo(container);
                        container.addClass('grid-cell-align-left');
                        $('<span />')
                            .text(options.data.Name2)
                            .appendTo(container);
                        container.addClass('grid-cell-align-left');
                    }
                }
            ],
            contentReadyAction: grdReadyAction,
            dataSource: $scope.customerGridDataSource(),
            filterRow: { visible: true },
            groupPanel: { visible: false },
            noDataText: "No Customers Found",
            paging: { pageSize: $scope.PageSize, pageIndex: PageIndex },
            pager: { visible: true, allowedPageSizes: [10, 20, 30], showPageSizeSelector: true },
            rowAlternationEnabled: false,
            selection: { mode: 'single' },
            selectionChanged: function (selectedRowsInfo) {
                if (selectedRowsInfo.selectedRowsData[0] != null) {
                    $scope.saveSelection(selectedRowsInfo);
                }
            },
            scrolling: { mode: 'standard' },
            showBorders: true,
            showColumnLines: true,
            showRowLines: false,
            sorting: { mode: 'none' },
            wordWrapEnabled: true
        });

        if (Key != null && Key > 0) {
            var dataGrid = $('#gridBillingCustomer').dxDataGrid('instance');
            (dataGrid as unknown as FacnmDx).selectRows([Key]);
        }
    };

    // Helping functions and events
    function grdReadyAction(e) {
        onWindowResize('#gridBillingCustomer', settings.GridMarginHeight);
    };
    
    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');                     
    };

    $scope.saveSelection = function(selectedRowsInfo) {
        if(!selectedRowsInfo) {
            $rootScope.user.DefaultCustomerId = $scope.TempDefaultCustomerId != null ? $scope.TempDefaultCustomerId : $rootScope.user.DefaultCustomerId;
            $rootScope.user.DefaultCustomerName = $scope.TempDefaultCustomerName != null ? $scope.TempDefaultCustomerName : $rootScope.user.DefaultCustomerName;
            $uibModalInstance.close();
        } 
        else {
        $scope.TempDefaultCustomerId = selectedRowsInfo.selectedRowsData[0].Id;
        $scope.TempDefaultCustomerName = selectedRowsInfo.selectedRowsData[0].Name1;
        }
    }

    collapsibleHeaderClickEvent($scope);

    $('body').on('click', function (e) {
        if ($(e.target).parents('[data-toggle="popover"]').length === 0) {
            $('[data-toggle="popover"]').popover('hide');
        }
    });

    
    // Initialization - this runs on load
    var init = function () {
        masterFactory.verifyAuthentication();

        $('#loadingModal').modal({ backdrop: 'static' });
        $q.all([
            CustomerFactory.getBillingCustomers($scope.filterOptions).success(function(data){
                $scope.BillingcustomerGridDataSource = data;
            }).error(function (data, status){
                masterFactory.setError(status, data, $scope);
            })
        ]).then(function () {
            $scope.refreshGrid(0, null);
            $('#loadingModal').modal('hide');
        });
    };

    init();

}]);
